module.exports = __webpack_public_path__ + "img/db2f72d5e3de6f24c9b18ffb16cffe7a.png";